<cap-content-header>
  <cap-title>
    {{ "Auftrag.SucheTitel" | translate }}
  </cap-title>
  <cap-title-functionbar>
    <button (click)="onNew()" [disabled]="!hasDatenexportAuftragAdminRight" class="btn btn-outline-primary btn-sm" type="button">
      <i class="fas fa-plus me-2"></i>{{ "functionbar.new" | translate }}
    </button>
  </cap-title-functionbar>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="'searchAuftrag'">
    <a ngbNavLink>{{ "Auftrag" | translate }}</a>
    <ng-template id="auftrag" ngbNavContent>
      <cap-auftrag-suche></cap-auftrag-suche>
    </ng-template>
  </li>

  <li [disabled]="true" [ngbNavItem]="'searchTemplate'">
    <a ngbNavLink>{{ "Template" | translate }}</a>
    <ng-template id="template" ngbNavContent>
      <!-- <cap-template-suche></cap-template-suche> -->
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
